<template>
  <div class="login">
    <div class="logo">
      <img src="assets/logo.png" alt="">
    </div>
    <div class="formLogin" v-if="validTokenValue">
      <input class="form_input" v-model="input.username" type="text" placeholder="Pseudo" required>
      <input v-model="input.email" class="form_input" type="mail"
             placeholder="Email" required>
      <input class="form_input" v-model="input.plainPassword" type="password" placeholder="Mot de passe" required>
      <input v-model="input.confirmPassword" class="form_input" type="password"
             placeholder="Confirmation mot de passe" required>
    </div>
    <div class="timeout" v-else>
      <p>Lien expiré</p>
    </div>
    <div class="content_response">
      <transition-group enter-active-class="animated bounceIn" name="list" tag="p"
                        leave-active-class="animated fadeOut">
        <div v-for="(response,index) in responses" class="form_response" :class="response.type" :key="index+'-p'">
          <p>{{ response.msg }}</p>
        </div>
      </transition-group>
    </div>
    <div class="connexion">
      <button class="button blue" v-on:click="registerUser()" v-if="tokenlink">Valider</button>
      <router-link to="/login/rp" class="button blue" v-else>Nouveau lien</router-link>
      <!--      <span @click="changeType('connexion')">Me connecter</span>-->
    </div>
  </div>

</template>

<script>
import {store} from '../store/store';
import {getMasks} from "@/service";
import {mapActions} from 'vuex'
import Loader from '../components/Loader/Loader.vue'
import router from "../router";


export default {

  name: 'ResetPassword',
  components: {
    Loader
  },
  data() {
    return {
      store,
      tokenlink: null,
      responses: null,
      validTokenValue: true,
      input: {
        username: "",
        plainPassword: "",
        email: "",
        confirmPassword: "",
      }
    }
  },
  methods: {

    ...mapActions([
      'newPassword',
    ]),
    registerUser() {
      const {username, plainPassword, email, confirmPassword} = this.input;
      this.responses = null
      if (username === '' || plainPassword === "" || confirmPassword === "" || email === "") {
        this.responses = [{
          msg: "Les champs ne doivent pas être vide",
          type: "error"
        }]
        this.removeResponse()

      } else if (this.input.plainPassword !== this.input.confirmPassword) {
        this.responses = [{
          msg: "Les deux mots passes doivent être identique",
          type: "error"
        }]
        this.removeResponse()


      } else {
        this.newPassword({id: this.tokenlink.p, pseudo: username, email: email, password: plainPassword}).then(res => {
          this.responses = res
          this.removeResponse()

          if (res[0].type === 'succeed') {
            router.push({name: "login", params: {type: 'connexion'}})

          }

        })
      }
    },
    setUser(user) {
      this.store.commit('setUser', user);
    },
    setMasks(masks) {
      this.store.commit('setMasks', masks);
    },
    removeResponse(list = this.responses) {

      setTimeout(function () {
        list.shift()
        if (list.length > 0) {
          this.removeResponse(list)
        }
      }.bind(this), 2000)

    },
    validToken() {
      this.tokenlink = JSON.parse(atob(this.$route.params.token));
      let currentDate = new Date();
      let dataDate = new Date(this.tokenlink.d)
      if (currentDate <= dataDate) {
        return true
      } else {
        this.tokenlink = null
        return false
      }
    }
  },
  mounted() {
    this.validTokenValue = this.validToken()
  },
  updated() {

  }
}
</script>

<style scoped>

.header {
  padding: 20px;
}

.login {
  height: 100vh;
}

.logo {
  display: flex;
}

.logo img {
  margin: auto;
}

.formLogin {
  display: flex;
  flex-direction: column;
  margin: 40px;
}

.logo img {
  width: 35%;
}


/*   OLD FORM INPUT

.form_input {
  font-size: 16px;
  border: none;
  border-bottom: 1px solid #00d6ff;
  padding:15px 20px;
  margin:5px 0 ;
}*/

.form_input {
  font-size: 11px;
  border: 1px solid #6e6c6c;
  box-shadow: 0px 3px 9px 1px rgba(0, 0, 0, 0.22);
  border-radius: 7px;
  padding: 10px 20px;
  margin: 7px 0;
}

.form_input:focus {
  outline: none;
}

.form_response.error {
  width: 75%;
  margin: 15px auto auto auto;
  background-color: #ff3333;
  color: #fff;
  border-radius: 10px;
  /*position: absolute;*/
  /*font-family: "Bebas Neue";*/
}

.form_response.succeed {
  width: 75%;
  margin: 15px auto auto auto;
  background-color: #65c249;
  color: #fff;
  border-radius: 10px;
  /*position: absolute;*/
  /*font-family: "Bebas Neue";*/
}

.content_response {
  position: absolute;
  top: 0;
  width: 100%;
}

.form_response p {
  /*font-family: Calibri;*/
  text-align: center;
  padding: 10px 10px;
  white-space: pre-line;
  font-weight: bold;
}

.login {
}

.connexion {
  width: 100%;
  display: flex;
}

.button {
  color: #fff;
  padding: 10px;
  font-size: 20px;
  width: 60%;
  border-radius: 10px;
  margin: auto;
  border: none;
  text-transform: uppercase;
  font-family: var(--main-title-font);
  box-shadow: 0px 3px 9px 1px #0000004f;
}

.red {
  background-color: red;
}

.blue {
  background: linear-gradient(#00CDF8, #00ABDD);
  /*transition:.3s;*/
  /*border:2px solid transparent;*/
}

.blue:hover {
  color: #00CDF8;
  border: 2px solid #00CDF8;
  background: #fff;
  cursor: pointer;
}

@media screen and (min-width: 780px) {
  .logo img {
    width: 20%;
  }

  .formLogin, .connexion {
    width: 30%;
    margin: auto;
  }

  .formLogin {
    margin: 40px auto;
  }


}

</style>
